import { Skeleton } from "@mui/material";
import React from "react";

const LoadingSkeleton = () => {
  return (
    <div>
      {[...Array(5)].map((_, index) => (
        <Skeleton
          key={index}
          sx={{ height: 100, borderRadius: 3 }}
          animation="wave"
        />
      ))}
    </div>
  );
};

export default LoadingSkeleton;
